import { Dialog } from "@dash/dialog";
import { Button } from "@dash/form";

import { packageWeightLimitKg } from "./constants";

type NoPackageDialogProps = {
  onClose: () => void;
};

export function NoPackageDialog({ onClose }: NoPackageDialogProps) {
  return (
    <Dialog header="Brak aktywnej paczki" onClose={onClose} css={{ maxWidth: "400px" }}>
      <div css={{ padding: "1rem 0" }}>
        Zanim zeskanujesz produkt, musisz najpierw zaznaczyć paczkę, do której ma zostać dodany.
      </div>
      <div css={{ display: "flex", justifyContent: "flex-end" }}>
        <Button onClick={onClose}>OK</Button>
      </div>
    </Dialog>
  );
}

type OverweightDialogProps = {
  onClose: () => void;
};

export function OverweightDialog({ onClose }: OverweightDialogProps) {
  return (
    <Dialog
      header="Przekroczony limit wagi"
      onClose={onClose}
      css={{ maxWidth: "400px" }}
    >
      <div css={{ padding: "1rem 0" }}>
        Nie możesz dodać więcej produktów do tej paczki, ponieważ przekroczyłbyś maksymalny
        limit wagi {packageWeightLimitKg} kg.
      </div>
      <div css={{ display: "flex", justifyContent: "flex-end" }}>
        <Button onClick={onClose}>OK</Button>
      </div>
    </Dialog>
  );
}
